import { useIntl } from 'react-intl';
import Button from '@rio-cloud/rio-uikit/Button';

type AegRequestFormFooterProps = {
    onCancel?: () => void;
    onSubmit?: () => void;
    isSubmitting?: boolean;
};

const AegRequestFormFooter = ({ onCancel, onSubmit, isSubmitting }: AegRequestFormFooterProps) => {
    const intl = useIntl();

    return (
        <div className='flex flex-col-reverse sm:flex-row sm:justify-end gap-2'>
            <Button onClick={onCancel}>
                {intl.formatMessage({ id: 'intl-msg:support.aeg.newRequest.button.cancel' })}
            </Button>
            <Button bsStyle='primary' onClick={onSubmit} disabled={isSubmitting}>
                {intl.formatMessage({ id: 'intl-msg:support.aeg.newRequest.button.create' })}
            </Button>
        </div>
    );
};

export default AegRequestFormFooter;
